import { UseMutationResult } from "@tanstack/react-query";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { FailureMessageWithRetryButton } from "shared/components/feedback/FailureMessageWithRetryButton";
import { ButtonGroup, DropsButton, Flex, Text } from "shared/components/Spor";

type CloseInformationProps = {
  closeMutation: UseMutationResult<any, Error, void, unknown>;
};

export const CloseInformation: FC<CloseInformationProps> = ({
  closeMutation,
}) => {
  const { t } = useTranslation();
  const [askConfirmation, setAskConfirmation] = useState<boolean>(false);
  const { mutate, isPending, isError } = closeMutation;
  if (isError) {
    return (
      <FailureMessageWithRetryButton
        customMessage={t("Kunne ikke friskmelde hendelsen")}
        retryFunction={() => mutate()}
      />
    );
  }
  return askConfirmation ? (
    <Flex alignItems="center" gap="8px" minWidth="fit-content">
      <Text>{t("Er du sikker?")}</Text>
      <ButtonGroup>
        <DropsButton
          variant="primary"
          size="xs"
          onClick={() => mutate()}
          loading={isPending}
        >
          {t("Ja, friskmeld")}
        </DropsButton>
        <DropsButton
          variant="tertiary"
          size="xs"
          onClick={() => setAskConfirmation(false)}
        >
          {t("Avbryt")}
        </DropsButton>
      </ButtonGroup>
    </Flex>
  ) : (
    <DropsButton
      size="xs"
      onClick={() => setAskConfirmation(true)}
      variant="tertiary"
    >
      {t("Friskmeld")}
    </DropsButton>
  );
};
